export default __webpack_public_path__ + "static/media/design-center-img-1.3c7c3916.png";